export default __webpack_public_path__ + "static/media/TUV_R_Trademark_1_Claim_sRGB_blue.8ff7fe1e.svg";